import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String
  }

  copy() {
    navigator.clipboard.writeText(this.textValue)
      .then(() => {
        // Optional: Add a visual feedback that the copy was successful
        this.element.classList.add("text-green-400")
        setTimeout(() => {
          this.element.classList.remove("text-green-400")
        }, 1000)
      })
      .catch(err => {
        console.error("Failed to copy text: ", err)
      })
  }
} 